import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import CrossBatchSearchResult from "../model/CrossBatchSearchResult";
import CrossBatchSearchRequest from "../request/CrossBatchSearchRequest";

const CrossBatchSearchApiService = async (
  request: CrossBatchSearchRequest
): Promise<CrossBatchSearchResult[]> => {
  const params: Record<string, string> = {
    search: request.search,
  };
  if (request.document_type) {
    params.document_type = request.document_type;
  }

  const { data } = await axios.get(
    "/document_processing_jobs/cross_batch_search/",
    { params }
  );
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCrossBatchSearchApiService = (request: CrossBatchSearchRequest) =>
  useQuery<
    CrossBatchSearchResult[],
    AxiosError,
    CrossBatchSearchResult[]
  >(
    ["CrossBatchSearchApiService", ...Object.values(request)],
    () => CrossBatchSearchApiService(request),
    {
      enabled: request.search.trim().length > 0,
      keepPreviousData: true,
    }
  );

export default useCrossBatchSearchApiService;
